import { NgModule } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { SelectCheckAllComponent } from './select-check-all/select-check-all.component';

@NgModule({
    imports: [MatSelectModule, MatCheckboxModule, TranslateModule, SelectCheckAllComponent],
    exports: [MatSelectModule, MatCheckboxModule, SelectCheckAllComponent],
})
export class CustomMaterialModule {}
